import { combineReducers } from 'core/redux'

import rule from './rule'
import totalCount from './totalCount'

export default combineReducers({
  rule,
  totalCount,
})
